// Components==============
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { encodeURL } from 'utilities/encodeURL';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import Modal from '../Modal';
import RichText from '../RichText';
import './index.module.scss';
// =========================

const buttonColors = Array(5)
    .fill(['#2db1d8', '#9879c3', '#f4bb56', '#3f3f93'])
    .flat();

const Popup = ({ popup, text, popupAccent, index }) => {
    const openUrlModal = useOpenUrlModal(`button-popup/${encodeURL(text)}`);

    return (
        <>
            <motion.button
                style={{ background: `${buttonColors[index]}` }}
                styleName="wrapper"
                type="button"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={openUrlModal}
            >
                <span>{text}</span>
            </motion.button>
            <AnimatePresence>
                <Modal
                    color={popupAccent}
                    slug={`button-popup/${encodeURL(text)}`}
                >
                    <div styleName="popup-wrapper">
                        <RichText accent={popupAccent} richText={popup} />
                    </div>
                </Modal>
            </AnimatePresence>
        </>
    );
};

export default function ColoredButton({ text, popup, index }) {
    return (
        <Popup
            popup={popup}
            text={text}
            index={index}
            popupAccent={buttonColors[index]}
        />
    );
}
